import { Map, MapBrowserEvent } from "ol";
import { useEffect } from "react";

export function useMouseEvents(
	map: Map | null,
	onPointerMove: (e: MapBrowserEvent<any>) => void,
) {
	useEffect(() => {
		if (!map) return () => {};

		map.on("pointermove", onPointerMove);

		return () => {
			map.un("pointermove", onPointerMove);
		};
	}, [map, onPointerMove]);
}